export default __webpack_public_path__ + "static/media/fish.8546b300.svg";